<template>
    <div class="coordinacion-registros">
        <div style="background: #E0F7FA; padding: 5px 10px; border-bottom: 1px solid #00BCD4">
            <el-row :gutter="20">
                <el-col :sm="12" :offset="0">
                    <h4 style="margin:10px 20px">COORDINACIÓN DE RECETAS / REGISTROS</h4>
                </el-col>

            </el-row>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CoordinacionRegistros',
    data() {
        return {
            registros: [
                { id: 1, nombre: 'Registro 1', fecha: '2024-01-15', estado: 'Activo' },
                { id: 2, nombre: 'Registro 2', fecha: '2024-01-16', estado: 'Pendiente' },
                { id: 3, nombre: 'Registro 3', fecha: '2024-01-17', estado: 'Completado' }
            ]
        }
    },
    methods: {
        editarRegistro(registro) {
            console.log('Editar registro:', registro)
        },
        eliminarRegistro(registro) {
            console.log('Eliminar registro:', registro)
        }
    }
}
</script>

<style lang="scss" scoped>
.coordinacion-registros {
    padding: 0px;
    
    h2 {
        color: #409EFF;
        margin-bottom: 30px;
    }
    
    .registros-content {
        .el-card {
            margin-bottom: 20px;
        }
    }
}
</style> 